import { render } from "./DossierTile.vue?vue&type=template&id=3a2af030"
import script from "./DossierTile.vue?vue&type=script&lang=js"
export * from "./DossierTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__